import React, { useState, useEffect, CSSProperties } from 'react';
import Checkbox from '@mui/material/Checkbox';

interface CheckboxComponentProps {
    checked: boolean | null | undefined;
    defaultChecked?: boolean;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    style?: CSSProperties;
    label?: string;
}

const CheckboxComponent: React.FC<CheckboxComponentProps> = ({
    ...props
}) => {
    const [isChecked, setIsChecked] = useState(props.defaultChecked !== undefined ? props.defaultChecked : !!props.checked);

    useEffect(() => {
        setIsChecked(props.defaultChecked !== undefined ? props.defaultChecked : !!props.checked);
    }, [props.checked, props.defaultChecked]);

    const handleChange = () => {
        if (!props.disabled) {
            const newChecked = !isChecked;
            setIsChecked(newChecked);
            if (props.onChange) {
                props.onChange(newChecked);
            }
        }
    };

    useEffect(() => {
        setIsChecked(!!props.checked); // null | undefined --» false
    }, [props.checked]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', ...props.style }}>
            {props.label && <span className="label" style={{ marginRight: '8px' }}>{props.label}:</span>}
            <Checkbox
                checked={isChecked}
                disabled={props.disabled}
                onChange={handleChange}
                color="primary"
            />
        </div>
    );
};

export default CheckboxComponent;